import type { ComponentType } from "react";
import type { Schema } from "@/shared/components/Form/types";
import type {
  CreateSchemaDefinition,
  EditSchemaDefinition,
} from "@/shared/components/CRUD/types";
import {
  CreateConfigMutation,
  UpdateConfigMutation,
  ConfigEditQuery,
  ConfigShowQuery,
  type UpdateConfigInput,
} from "@/admin/entities/configs";
import type {
  ConfigEditQueryType,
  ConfigShowQueryType,
} from "@/types/graphql/admin.generated";

export const filterSchema: Schema = {
  search: {
    label: "Поиск",
    type: "text",
    placeholder: "Поиск по ключу...",
    xs: 12,
    fullWidth: true,
    priority: "primary",
  },
  withDeleted: {
    label: "Показывать удалённые",
    type: "checkbox",
    priority: "secondary",
    xs: 12,
    md: 6,
    fullWidth: true,
  },
  deleted: {
    label: "Статус",
    type: "select",
    priority: "secondary",
    xs: 12,
    md: 6,
    fullWidth: true,
    options: [
      { label: "Все активные и удалённые", value: "" },
      { label: "Только активные", value: "false" },
      { label: "Только удалённые", value: "true" },
    ],
  },
};

const mainFieldsSchema: Schema = {
  key: {
    required: true,
    label: "Ключ",
    helperText: "Например mailer.partner или support.email",
    type: "text",
    xs: 12,
    md: 6,
    fullWidth: true,
  },
  value: {
    label: "Значение",
    type: "text",
    multiline: true,
    xs: 12,
    md: 6,
    fullWidth: true,
  },
};

export const createSchema: CreateSchemaDefinition = {
  main: {
    label: "Основные настройки",
    createMutation: CreateConfigMutation,
    schema: mainFieldsSchema,
  },
} as const;

export const editSchemaBase: EditSchemaDefinition = {
  details: {
    label: "Просмотр",
    type: "show" as const,
    getTitle: (data: unknown) => {
      const typed = data as ConfigShowQueryType;
      return typed?.config?.key ?? null;
    },
    showQuery: ConfigShowQuery,
  },
  edit: {
    label: "Основные настройки",
    type: "form" as const,
    getTitle: (data: unknown) => {
      const typed = data as ConfigShowQueryType;
      return typed?.config?.key ?? null;
    },
    updateMutation: UpdateConfigMutation,
    editQuery: ConfigEditQuery,
    schema: mainFieldsSchema,
    getEditData: (data: unknown): UpdateConfigInput => {
      const { config: c } = data as ConfigEditQueryType;
      return {
        key: c.key,
        value: c.value ?? null,
      };
    },
  },
} as const;

export function createEditSchema(
  showComponent: ComponentType<{ editData?: unknown; id?: string }>
): EditSchemaDefinition {
  return {
    ...editSchemaBase,
    details: {
      ...editSchemaBase.details,
      showComponent,
    },
  };
}
